import { cn, tailwindUtils } from '@/shared/ui/utils/tailwind';
import { drawerSubmitButtonClass } from '@/shared/ui/utils/drawer-submit-button';
import { UnstyledButton } from '@/shared/ui';

export type DealDrawerSubmitButtonProps = {
  label: string;
  savingLabel: string;
  disabled: boolean;
  loading?: boolean;
  onClick: () => void;
};

/**
 * Footer submit button for the deal drawer (auto width, not full-bleed).
 *
 * @param props - The button label, saving label, disabled flag, and click handler.
 * @returns The rendered submit button.
 */
export function DealDrawerSubmitButton({
  label,
  savingLabel,
  disabled,
  loading = disabled,
  onClick,
}: DealDrawerSubmitButtonProps) {
  return (
    <UnstyledButton
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label={label}
      data-testid="deal-drawer-submit"
      className={cn(
        tailwindUtils.buttonBase,
        drawerSubmitButtonClass,
      )}
    >
      {loading ? savingLabel : label}
    </UnstyledButton>
  );
}
